module.exports = __webpack_public_path__ + "img/mirror01.b32085f3.jpg";